import { createContext, useContext, useEffect, useState } from "react";
import { content } from "./content";

const LangCtx = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "en";
    return window.localStorage.getItem("osrelis-lang") || "en";
  });

  const setLang = (l) => {
    setLangState(l);
    try {
      window.localStorage.setItem("osrelis-lang", l);
    } catch (e) {
      /* ignore */
    }
  };

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  return <LangCtx.Provider value={{ lang, setLang, c: content[lang] }}>{children}</LangCtx.Provider>;
};

export const useLang = () => {
  const ctx = useContext(LangCtx);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};

// Split inline text on *emphasis* markers → teal italic accent.
export const richParts = (text) =>
  String(text)
    .split(/(\*[^*]+\*)/g)
    .map((part, i) =>
      part.startsWith("*") && part.endsWith("*") ? (
        <em key={i} className="italic text-sage">
          {part.slice(1, -1)}
        </em>
      ) : (
        <span key={i}>{part}</span>
      )
    );

// Multi-line rich text: "\n" becomes block lines, *emphasis* becomes accent.
export const Rich = ({ text }) => {
  if (text == null) return null;
  return String(text)
    .split("\n")
    .map((line, i) => (
      <span key={i} className="block">
        {richParts(line)}
      </span>
    ));
};
